if (!customElements.get('bundle-form')) {
  class BundleForm extends HTMLElement {
    form = undefined;
    submitButton = undefined;
    cartDrawer = undefined;

    constructor() {
      super();
    }

    connectedCallback() {
      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('button[type="submit"]');
      this.cartDrawer = document.querySelector('cart-drawer');

      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    onSubmit(event) {
      event.preventDefault();
      this.submitButton.classList.add('disabled');

      addToCart(
        this.form,
        this.cartDrawer
          .getSectionsToRender()
          .map(section => section.section)
      )
        .then(response => {
          if (response.status) {
            this.recipientForm?.displayErrorMessage(response.errors);
            return;
          }

          this.cartDrawer.renderContents(response);
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          this.submitButton.classList.remove('disabled');
        });
    }
  }
  customElements.define('bundle-form', BundleForm);
}